// js/AudioManager.js
import AccessibilityManager from './core/AccessibilityManager.js'; // Import dependency

export default class AudioManager { // Add export default
  /**
   * @param {AccessibilityManager} accessibilityManager
   */
  constructor(accessibilityManager) {
    if (!(accessibilityManager instanceof AccessibilityManager)) {
      console.warn("AudioManager: AccessibilityManager instance not provided correctly.");
      this.accessibilityManager = { isReducedMotionMode: false }; // Dummy fallback
    } else {
      this.accessibilityManager = accessibilityManager;
    }
    this.sounds = {};
    this.isMuted = false;
    this.volume = 1.0;

    this._loadSounds();
  }

  /**
   * Preload known sounds.
   */
  _loadSounds() {
    const fireworkSoundElement = document.getElementById('firework-sound');
    if (fireworkSoundElement) {
      this.sounds['firework'] = fireworkSoundElement;
      fireworkSoundElement.load();
      console.log("AudioManager: Firework sound loaded.");
    } else {
      console.warn("AudioManager: Firework sound element not found.");
    }
  }

  /**
   * Play a loaded sound.
   * @param {string} soundId - The ID of the sound to play (e.g., 'firework')
   */
  playSound(soundId) {
    if (this.accessibilityManager?.isReducedMotionMode) {
      return;
    }

    if (this.isMuted) {
      return;
    }

    const sound = this.sounds[soundId];
    if (sound) {
      sound.volume = this.volume;
      sound.currentTime = 0;
      sound.play().catch(error => {
        console.warn(`AudioManager: Could not play sound '${soundId}'. Error: ${error.message}`);
      });
    } else {
      console.warn(`AudioManager: Sound ID '${soundId}' not found.`);
    }
  }

  setVolume(level) {
    this.volume = Math.max(0, Math.min(1, level));
    console.log(`AudioManager: Volume set to ${this.volume}`);
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    console.log(`AudioManager: Muted set to ${this.isMuted}`);
  }
}
// Removed window export
